module.exports = __webpack_public_path__ + "static/img/2_1_2.1ca8a7e3.jpg";